import React from "react";
import PropTypes from "prop-types";
import { AI_TOOL_NAMES } from "../../constants";

const AIFormSubheading = ({ toolName }) => {
  switch (toolName) {
    case AI_TOOL_NAMES.ASK_AI:
      return (
        <div className="subtitle-1">
          The only tool that combines the world&apos;s best literary analysis
          with the power of AI.
        </div>
      );
    case AI_TOOL_NAMES.DISCUSSION_QUESTIONS:
      return (
        <div className="subtitle-1">
          Instantly generate discussion questions by combining the world&apos;s
          best literary analysis with the power of AI.
        </div>
      );
    case AI_TOOL_NAMES.QUIZ_QUESTIONS:
      return (
        <div className="subtitle-1">
          Instantly generate quiz questions by combining the world&apos;s best
          literary analysis with the power of AI.
        </div>
      );
    case AI_TOOL_NAMES.ESSAY_PROMPTS:
      return (
        <div className="subtitle-1">
          Instantly generate essay prompts by combining the world&apos;s best
          literary analysis with the power of AI.
        </div>
      );
    default:
      return null;
  }
};

AIFormSubheading.propTypes = {
  toolName: PropTypes.oneOf(Object.values(AI_TOOL_NAMES)).isRequired
};

export default AIFormSubheading;
